import React from 'react';
import { Helmet } from 'react-helmet-async';
import { site } from '../../config/site';

/**
 * <title>, meta description, canonical, Open Graph y Twitter Card de una vista.
 *
 * Cholloman no tiene router: las vistas viven en el fragmento (`#TopChollosPage`).
 * Google ignora el fragmento, así que TODAS las vistas son para él la misma URL
 * `/`. Por eso el `path` por defecto es `/` y el canonical no cambia entre vistas:
 * lo que sí cambia es el título de la pestaña y lo que ve quien comparte desde un
 * navegador con JS.
 *
 * Límite conocido: los bots de vista previa (WhatsApp, Facebook, X) no ejecutan
 * JS y leen sólo el `<head>` estático de public/index.html. Ver docs/SEO.md.
 */
export default function Seo({
  title,
  description,
  path = '/',
  image,
  locale = 'es_ES',
  noindex = false,
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} · ${site.name}` : `${site.name} — ${site.tagline}`;
  const desc = description || site.description;
  const url = `${site.url}${path}`;
  const img = image || site.logo;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:locale" content={locale} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
